import { spawn } from 'redux-saga/effects';
import { sagas as resizeSagas } from './resize';
import { sagas as consoleSagas } from './console';
import { sagas as taskSchedulerSagas } from './taskScheduler';

export default function* sagas() {
	yield spawn(resizeSagas);
	yield spawn(taskSchedulerSagas);
	yield spawn(consoleSagas);
}
